module.exports = __webpack_public_path__ + "img/kc8.042fb63c.png";